import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DisbursementCoverMemoGroupsParams,
  DisbursementCoverMemoGroupsResponse,
  DisbursementCoverMemoIssuePayload,
  DisbursementCoverMemoModel,
  DisbursementCoverMemoUpdatePayload,
} from '../../models/disbursement/disbursement-cover-memo.model';

// Disbursement cover memo (ใบปะหน้า) service for batch cover-memo rounds.
@Injectable({
  providedIn: 'root',
})
export class DisbursementCoverMemoService {
  private apiUrl = '/disbursement_cover_memos';

  #http = inject(HttpClient);

  getRows(params: DisbursementCoverMemoGroupsParams): Observable<DisbursementCoverMemoGroupsResponse> {
    const httpParams = new HttpParams().set('academic_term_id', String(params.academic_term_id));

    return this.#http.get<DisbursementCoverMemoGroupsResponse>(this.apiUrl, { params: httpParams });
  }

  getInternationalRows(
    params: DisbursementCoverMemoGroupsParams,
  ): Observable<DisbursementCoverMemoGroupsResponse> {
    const httpParams = new HttpParams().set('academic_term_id', String(params.academic_term_id));

    return this.#http.get<DisbursementCoverMemoGroupsResponse>(
      `${this.apiUrl}/international`,
      { params: httpParams },
    );
  }

  preview(payload: DisbursementCoverMemoIssuePayload): Observable<Blob> {
    return this.#http.post(`${this.apiUrl}/preview`, payload, { responseType: 'blob' });
  }

  create(payload: DisbursementCoverMemoIssuePayload): Observable<DisbursementCoverMemoModel> {
    return this.#http.post<DisbursementCoverMemoModel>(this.apiUrl, payload);
  }

  update(id: number, payload: DisbursementCoverMemoUpdatePayload): Observable<DisbursementCoverMemoModel> {
    return this.#http.patch<DisbursementCoverMemoModel>(`${this.apiUrl}/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this.#http.delete<void>(`${this.apiUrl}/${id}`);
  }

  download(id: number): Observable<Blob> {
    return this.#http.get(`${this.apiUrl}/${id}/download`, { responseType: 'blob' });
  }
}
